export default "__VITE_ASSET__Ck4HmQEw__"